var pingPong = (function() {
    var MAX_MESSAGE_LIFE = 10; // sec
    var RECEIVE_INTERVAL = 1; // sec
    var INSTANCE_ID_LIFE = 172800; // sec // 2 days

    var _domain, _maxMessageLife, _logActivity, _initOk;

    function setCookie(channel, domain, lifeTime, msg) {
        var d = new Date();
        d.setTime(d.getTime() + (lifeTime * 1000)); // current + 10 sec
        var expires = 'expires=' + d.toUTCString() + ';';
        var domain = domain ? 'domain=' + domain  + ';' : '';
        document.cookie = channel + '=' + msg + ';' + expires + domain + 'path=/';
    }

    function getCookie(channel) {
        var name = channel + '=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }

        return '';
    }

    function getUniqueId() {
        return (new Date()).getTime() + '-' + Math.random().toString(36).substr(2, 5);
    }

    return {
        init : function(config) {
            var parsedHostname = psl.parse(window.location.hostname);
            _domain = parsedHostname.domain ? parsedHostname.domain : null;
            if (!_domain) {
                console.error('PingPong: Unable to get domain');
                return;
            }

            _maxMessageLife = config && config.hasOwnProperty('maxMessageLife') ? config.maxMessageLife : MAX_MESSAGE_LIFE;
            _logActivity = config && config.hasOwnProperty('logActivity') ? config.logActivity : false;

            _initOk = true;
        },
        send : function(channel, msg) {

            if (!_initOk) {
                console.error('PingPong: Init error');
                return;
            }

            if (!channel || !msg) {
                console.error('PingPong: Channel name & message is required');
                return;
            }

            var payload = JSON.stringify({
                uid: getUniqueId(),
                msg: msg
            });

            setCookie(channel, _domain, _maxMessageLife, payload);

            if (_logActivity === true) {
                console.log('PingPong: Channel - ' + channel + ', Sent: ' + payload);
            }
        },
        receive : function(channel, interval, onReceiveCallback) {

            if (!_initOk) {
                console.error('PingPong: Init error');
                return;
            }

            if (typeof onReceiveCallback !== 'function') {
                console.error('PingPong: Invalid input for receive. Input must be function.');
                return;
            }

            if (!channel) {
                console.error('PingPong: Channel name is required');
                return;
            }

            interval = (interval ? interval : RECEIVE_INTERVAL) * 1000;
            var instanceId = getUniqueId();

            window.setInterval(function() {
                var msg = getCookie(channel);

                if (msg) {
                    var msgParsed = JSON.parse(msg);
                    var lastMessageId = getCookie(instanceId);
                    if (msgParsed.uid !== lastMessageId) {
                        onReceiveCallback(msgParsed);
                        setCookie(instanceId, _domain, INSTANCE_ID_LIFE, msgParsed.uid);
                    }
                }

                if (_logActivity === true) {
                    console.log('PingPong: Channel - ' + channel + ', Received: ' + msg);
                }

            }, interval);
        }
    }
})();